/**
 * Business rule: Invoice billing is only offered for orders of at least this
 * many screens. Enforced in `usePaymentShippingForm` (gates step-3 Continue) and
 * surfaced by `InvoiceNotice`. Single source so the copy and the validation can
 * never drift.
 */
export const INVOICE_MIN_SCREENS = 5;

/**
 * Why the selected Invoice method is not available for the current selection —
 * the two business rules the invoice notice states:
 *
 * - `monthly`: invoice billing is an annual-only option.
 * - `below_minimum`: the order is under {@link INVOICE_MIN_SCREENS} screens.
 *
 * Derived in `usePaymentShippingForm` (which gates step-3 Continue on it) and
 * rendered as the matching error copy by `InvoiceNotice`. `undefined` means
 * invoice is fine (or isn't the selected method).
 */
export type InvoiceUnavailableReason = "monthly" | "below_minimum";
